import {inject, observer} from "mobx-react";
import React from "react";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import rem from "../utils/rem";
import Box from "@material-ui/core/Box";
import ChevronLeft from "mdi-material-ui/ChevronLeft";
import ChevronRight from "mdi-material-ui/ChevronRight";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const DateInput = styled.input`
  text-align: center;
  line-height: ${rem(16)};
  border-radius: ${rem(4)};
  border: 1px solid #aeaeae;
  font-size: ${rem(13)};
  padding: ${rem(6)} 0 ${rem(6)} 0;
  cursor: pointer;
`;

const datePickerPopperConfig = {
  popperProps: {
    strategy: "fixed"
  },
  popperPlacement: "bottom",
  popperModifiers: [
    {
      name: "preventOverflow",
      options: {
        enabled: false
      }
    },
    {
      name: "flip",
      options: {
        enabled: false
      }
    }
  ]
};

const styles = theme => ({
  dialogContent: {
    marginBottom: 25
  }
});

class MatchupsDialog extends React.Component {

  render() {
    const {matchupsDialogStore, sportsReferenceStore} = this.props;

    return (
        <Dialog
            fullWidth={true}
            maxWidth="xs"
            open={matchupsDialogStore.isOpen}
            onClose={() => matchupsDialogStore.close()}
        >
          <DialogTitle>
            <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1rem"
                }}
            >
              <Typography variant="h6">Today&apos;s Matchups</Typography>
              <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.25rem"
                  }}
              >
                <IconButton
                    onClick={() => matchupsDialogStore.subtractDay()}
                    size="small"
                >
                  <ChevronLeft/>
                </IconButton>
                <DatePicker
                    selected={matchupsDialogStore.date}
                    onChange={date => matchupsDialogStore.setDate(date)}
                    customInput={<DateInput/>}
                    {...datePickerPopperConfig}
                />
                <IconButton
                    onClick={() => matchupsDialogStore.addDay()}
                    size="small"
                >
                  <ChevronRight/>
                </IconButton>
              </Box>
              <Select
                  autoWidth={true}
                  style={{minWidth: "6.5rem"}}
                  value={matchupsDialogStore.selectedLeague}
                  onChange={event =>
                      matchupsDialogStore.setSelectedLeague(event.target.value)
                  }
              >
                {sportsReferenceStore.sports.map(sport => (
                    <MenuItem
                        key={sport.name + sport.id}
                        value={sport.id}
                    >
                      {sport.name}
                    </MenuItem>
                ))}
              </Select>
            </Box>
          </DialogTitle>
          <DialogContent style={{padding: "0 0 0 3rem"}}>
            <FormControl component="fieldset">
              <FormGroup
                  key={matchupsDialogStore.matchups.title}
                  style={{marginBottom: "1rem"}}
              >
                {matchupsDialogStore.matchups.matchups.length > 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={matchupsDialogStore.selected.size === matchupsDialogStore.matchups.matchups.length}
                        onChange={(e, checked) =>
                          checked
                            ? matchupsDialogStore.selectAll()
                            : matchupsDialogStore.unselectAll()
                        }
                      />
                    }
                    label={<strong>Select All</strong>}
                  />
                )}
                {matchupsDialogStore.matchups.matchups.length > 0 ? (
                    matchupsDialogStore.matchups.matchups.map(matchup => (
                        <FormControlLabel
                            key={matchup.value}
                            control={
                              <Checkbox
                                  checked={matchupsDialogStore.selected.has(
                                      matchup.value
                                  )}
                                  onChange={(e, checked) =>
                                      checked
                                          ? matchupsDialogStore.addMatchup(matchup.value)
                                          : matchupsDialogStore.removeMatchup(matchup.value)
                                  }
                                  value={matchup.value}
                              />
                            }
                            label={matchup.label}
                        />
                    ))
                ) : (
                    <Typography variant="body2">No Games Today</Typography>
                )}
              </FormGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => matchupsDialogStore.close()} color="secondary">
              Close
            </Button>
            <Button
                onClick={() => matchupsDialogStore.addToQuery()}
                color="primary"
                disabled={matchupsDialogStore.selected.size === 0}
            >
              Add to query
            </Button>
          </DialogActions>
        </Dialog>
    );
  }
}

export default inject("matchupsDialogStore", "sportsReferenceStore")(
    withStyles(styles)(observer(MatchupsDialog))
);



// WEBPACK FOOTER //
// ./src/components/MatchupsDialog.js